<template>
  <module-page v-bind="pageParams">
    <v-layout row wrap >
      <v-flex xs12>
        <v-card class="blockade-warning__card" :color="warning.bgColor" outlined tile >
          <div class="blockade-warning__card-container">
            <v-img v-if="warning.thumbnail"
              class="blockade-warning__img-container"
              :src="warning.thumbnail"
            >
            </v-img>

            <div class="blockade-warning__card-container-description">
              <div v-if="warning.title" class="blockade-warning__card-container-title">
                <h2 :style="{ color: warning.textColor}">{{ warning.title }}</h2>
              </div>

              <p :style="{ color: warning.textColor}">{{ warning.message }}</p>
            </div>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </module-page>
</template>

<script>
import ModulePage from '@/components/layout/Page';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import { APP } from '@/utils/constants';
import { CONFIG } from '../../utils/constants';
export default {
  name: 'blockadeWarning',
  components: {
    ModulePage,
    ScreenLoading,
  },
  computed: {},
  data() {
    return {
      warning: {
        title: "Aviso",
        message: "Prezado cliente, no momento o Portal do Cliente está em manutenção. Por favor, retorne mais tarde",
        bgColor: '#ffebb1',
        textColor: '#ff0000'
      }
    };
  },
  created() {
    this.pageParams = this.$store.getters[APP.PAGES].blockadeWarning;
    if(!this.$store.getters[CONFIG.SHOW_BLOCKADE_WARNING]){
      this.$router.replace({ name: 'home'})
    }
    if(this.$store.getters[APP.BLOCKADE_WARNING]){
      this.warning = this.$store.getters[APP.BLOCKADE_WARNING];
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.blockade-warning {
  @include breakpoint(mobile) {
    &__card {
      margin: 6px 6px !important;
    }
    &__card-container {
      flex-direction: column;
    }

    &__card-container-description {
      padding: 20px !important;
      width: auto !important;
    }
  }

  &__card {
    margin: 60px 60px;
  }
  &__card-container {
    display: flex;
  }

  &__card-container-description {
    padding: 60px;
    white-space: pre-wrap;
  }

  &__card-container-title {
    h2 {
      display: inline-block;
    }
    span {
      float: right;
    }
  }

  &__img-container {
    min-width: 320px;
    min-height: 180px;

    &:hover {
      opacity: 0.5;
      cursor: pointer;
    }

    .play {
      position: relative;
      top: 50%;
      left: 50%;
      width: 80px;
      height: 80px;
      margin: -40px 0 0 -40px;
    }
  }

  &__video-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/app/BlockadeWarning.vue